var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, QueryList, AfterContentInit, OnDestroy, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { TabComponent } from '../tab/tab.component';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil, pairwise, filter } from 'rxjs/operators';
var TabItem = /** @class */ (function () {
    function TabItem() {
    }
    return TabItem;
}());
var TabsComponent = /** @class */ (function () {
    function TabsComponent(changeDetector) {
        this.changeDetector = changeDetector;
        this.display = 'normal';
        this.activeTabChange = new EventEmitter();
        this._activeTab = new BehaviorSubject(0);
        this.tabSize = 'small';
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(TabsComponent.prototype, "activeTab", {
        get: function () {
            return this._activeTab.value;
        },
        set: function (value) {
            if (value != null) {
                if (typeof value === 'string') {
                    value = value.toUpperCase();
                }
                this._activeTab.next(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabsComponent.prototype, "tabItems", {
        get: function () {
            return this._tabItems;
        },
        set: function (value) {
            this._tabItems = value;
        },
        enumerable: true,
        configurable: true
    });
    TabsComponent.prototype.ngOnInit = function () {
    };
    TabsComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._tabs.changes
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (tabs) {
            _this.mapTabs();
            _this.changeDetector.markForCheck();
        });
        this.mapTabs();
        this._activeTab
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (tab) {
            _this.showTab(tab);
        });
        // notify selected tab
        this._activeTab
            .pipe(pairwise(), filter(function (_a) {
            var _b = __read(_a, 2), previousTab = _b[0], currentTab = _b[1];
            return previousTab !== currentTab;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (_a) {
            var _b = __read(_a, 2), previousTab = _b[0], currentTab = _b[1];
            _this.activeTabChange.next(currentTab);
        });
    };
    TabsComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    TabsComponent.prototype.handleTabSelect = function (tabItem) {
        this._activeTab.next(tabItem.index);
    };
    TabsComponent.prototype.mapTabs = function () {
        this.tabItems = this._tabs.map(function (tab, index) {
            return {
                index: index,
                label: tab.label || "Item " + index,
                tab: tab
            };
        });
    };
    TabsComponent.prototype.showTab = function (tabSelector) {
        this._tabs.forEach(function (_tab, _index) {
            switch (typeof tabSelector) {
                case 'number':
                    _tab.isActive = (tabSelector === _index);
                    break;
                case 'string':
                    _tab.isActive = (tabSelector.toString().toUpperCase() === _tab.label.toUpperCase());
                    break;
            }
        });
        this.changeDetector.markForCheck();
    };
    TabsComponent.prototype.isTabActive = function (tabItem) {
        var tabValue = (typeof this._activeTab.value === 'string') ? tabItem.label.toUpperCase() : tabItem.index;
        return tabValue === this._activeTab.value;
    };
    return TabsComponent;
}());
export { TabsComponent };
